module.exports = __webpack_public_path__ + "media/images/like/heart-31e0727b2ded9d9d12f749d497435ace.png";